import { useState } from 'react';
import { Input, Select } from 'semantic-ui-react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { formSelectService, generateTimeArray, searchSelectProps } from 'src/components/helpers';
import moment from 'src/services/moment_instance';
import NamePersonalization from '../namePersonalization';
import { FormSection } from './FormSection';
import { Field, FieldGrid } from '../serviceFormStyles';
import { getEffectiveSlugname } from '../serviceFormUtils';

const timeOptions = generateTimeArray().map((time) => ({ key: time, value: time, text: time }));

const RequiredError = ({ show }) =>
  show ? <p className="field__error">Campo obligatorio</p> : null;

const BasicDataSection = ({
  inputs,
  setInputs,
  updateInputs,
  handleInputs,
  selectHandle,
  errorInputs,
  eventNames,
}) => {
  const [dateFocused, set_dateFocused] = useState(false);
  const selectedDate = inputs.date ? moment(inputs.date) : null;
  const currentSlug = getEffectiveSlugname(inputs);
  const nameOptions =
    !currentSlug || eventNames.includes(currentSlug) ? eventNames : [currentSlug, ...eventNames];

  const onSelectName = (event, data) => {
    updateInputs({ eventSlugname: data.value, newEventSlugname: '' });
  };

  return (
    <FormSection
      id="datos-basicos"
      number={1}
      title="Datos básicos"
      description="Nombre, fecha, hora y cupo del evento."
      raised={dateFocused}
    >
      <FieldGrid>
        <Field className={`field--wide ${errorInputs.eventSlugname ? 'field--error' : ''}`}>
          <label htmlFor="eventSlugname">Nombre del evento</label>
          <div className="field__row">
            {formSelectService({
              Select,
              label: 'Selecciona un evento',
              name: 'eventSlugname',
              handler: onSelectName,
              value: currentSlug,
              options: nameOptions,
              search: true,
              errorInputs,
            })}
            <NamePersonalization setInputs={setInputs} inputs={inputs} />
          </div>
          <p className="field__hint">
            Elige un evento existente o personaliza el nombre para crear uno nuevo.
          </p>
          <RequiredError show={errorInputs.eventSlugname} />
        </Field>

        <Field className={errorInputs.date ? 'field--error' : ''}>
          <label htmlFor="date">Fecha</label>
          <SingleDatePicker
            id="date"
            date={selectedDate?.isValid() ? selectedDate : null}
            onDateChange={(newDate) =>
              handleInputs({ target: { name: 'date', value: newDate ? newDate.toDate() : null } })
            }
            focused={dateFocused}
            onFocusChange={({ focused }) => set_dateFocused(focused)}
            placeholder="dd/mm/aaaa"
            showDefaultInputIcon
            numberOfMonths={1}
            displayFormat="DD/MM/YYYY"
            isOutsideRange={() => false}
            block
          />
          {selectedDate?.isValid() && (
            <p className="field__hint">{selectedDate.format('dddd DD [de] MMMM [de] YYYY')}</p>
          )}
          <RequiredError show={errorInputs.date} />
        </Field>

        <Field>
          <label htmlFor="time">Hora</label>
          <Select
            id="time"
            placeholder="Selecciona la hora"
            error={Boolean(errorInputs.time)}
            fluid
            {...searchSelectProps({
              name: 'time',
              value: inputs.time,
              handler: selectHandle,
              options: timeOptions,
            })}
          />
          <RequiredError show={errorInputs.time} />
        </Field>

        <Field>
          <label htmlFor="capacity">Capacidad máxima</label>
          <Input
            id="capacity"
            name="capacity"
            type="number"
            min={0}
            placeholder="Ej. 300"
            value={inputs.capacity ?? ''}
            onChange={handleInputs}
            error={Boolean(errorInputs.capacity)}
            fluid
          />
          <RequiredError show={errorInputs.capacity} />
        </Field>
      </FieldGrid>
    </FormSection>
  );
};

export default BasicDataSection;
